import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/senso-tape/htdocs/senso-tape.com.ua/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/senso-tape/htdocs/senso-tape.com.ua/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/home/senso-tape/htdocs/senso-tape.com.ua/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/senso-tape/htdocs/senso-tape.com.ua/src/components/common/Header.tsx");
